
import React from 'react';

export default function KombaiWrapper({ children }) {
  return <>{children}</>;
}
